import { useEffect } from 'react';

export const useAutoSizeTextArea = (
	textAreaRef: HTMLTextAreaElement | null,
	value: number | ReadonlyArray<string> | string | undefined
) => {
	useEffect(() => {
		const updateSize = () => {
			if (textAreaRef) {
				textAreaRef.style.height = '0px';
				const scrollHeight = textAreaRef.scrollHeight;

				textAreaRef.style.height = scrollHeight + 'px';
			}
		};

		window.addEventListener('resize', updateSize);
		updateSize();

		return () => window.removeEventListener('resize', updateSize);
	}, [textAreaRef, value]);
};
